
import { Component, Prop, Vue } from 'vue-property-decorator';
import DateRange from '@/components/DateRange.vue';
import { Route } from 'vue-router';
import api from '@/api';
import Util from '@/utils/util';

const { member } = api;

@Component({
  components: { DateRange },
})
export default class UserPointList extends Vue {
  @Prop({ required: true }) private userId!: string;

  private data = { data: [], totalCount: 0, pageSize: 20, pageNo: 0 };

  private panel = 0;

  private loading = false;

  private tranTypes = [
    { value: null, text: '所有' },
    { value: 1, text: '好友轉讓' },
    { value: 2, text: 'SP序號加點兌換' },
    { value: 3, text: '使用點數兌換外部品項' },
    { value: 4, text: '系統給點' },
    { value: 5, text: '活動贈點' },
    { value: 6, text: '邀請好友贈點' },
    { value: 7, text: '支付點數扣點' },
    { value: 8, text: '交易手續費' },
    { value: 9, text: '交易虛擬貨幣' },
    { value: 10, text: '退款' },
    { value: 11, text: '點數回饋' },
    { value: 12, text: '推薦贈禮' },
    { value: 13, text: '問卷贈點' },
    { value: 14, text: '活動贈點' },
    { value: 15, text: '任務獎勵' },
  ];

  private headers = [
    { text: '時間', value: 'createdOn', width: 150 },
    { text: '交易類別', value: 'tranType', width: 150 },
    { text: '點數', value: 'pointValue', width: 150 },
    { text: '備註', value: 'remark' },
    { text: '明細', value: 'actions', width: 80 },
  ];

  private filter = {
    pageSize: Util.isNullOrUndefined(this.$route.query.pageSize)
      ? 20
      : +this.$route.query.pageSize,
    pageNo: Util.isNullOrUndefined(this.$route.query.pageNo)
      ? 1
      : +this.$route.query.pageNo,
    startOn: this.$route.query.startOn || undefined,
    endOn: this.$route.query.endOn || undefined,
    tranType: Util.isNullOrUndefined(this.$route.query.tranType)
      ? null
      : +this.$route.query.tranType,
    transactionId: this.$route.query.transactionId || undefined,
  };

  private get pageCount() {
    return Math.ceil((this.data.totalCount || 0) / (this.data.pageSize || 20));
  }

  private async query() {
    const query = {
      ...this.filter,
      pageSize: `${this.filter.pageSize}`,
      pageNo: `${this.filter.pageNo}`,
      tranType: this.filter.tranType ? `${this.filter.tranType}` : undefined,
    };
    if (this.isQueryChanged(query)) {
      await this.$router.replace({ query });
    }
    await this.requestData();
  }

  private async reset() {
    this.filter = {
      pageSize: 20,
      pageNo: 1,
      startOn: undefined,
      endOn: undefined,
      tranType: null,
      transactionId: undefined,
    };
    await this.query();
  }

  private isQueryChanged(query: {
    [key: string]: string | Array<string | null> | null | undefined;
  }): boolean {
    return !Object.keys(query).every(
      (key: string) => query[key]?.toString() === this.$route.query[key],
    );
  }

  private async requestData() {
    this.loading = true;
    const { data } = await member.listPoints(this.userId, this.filter);
    this.data = data;
    this.loading = false;
  }

  private async updatePage(page: number) {
    this.filter.pageNo = page;
    await this.query();
  }

  private async search() {
    this.filter.pageNo = 1;
    await this.query();
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: (vm: UserPointList) => void) => void,
  ) {
    await next(async (vm) => {
      await vm.requestData();
    });
  }
}
